function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 195.87,
  y1: 453.6,
  x2: 195.87,
  y2: -0.46,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#1e84c7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#2ea8e0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#3099d6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#3472bb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3a449c"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Logo1");

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "212.21 405.15 212.21 373.88 391.73 270.24 391.73 232.49 212.21 336.14 212.21 304.62 391.73 200.97 391.73 163.23 212.21 266.87 212.21 235.6 391.73 131.95 391.73 113.08 195.87 0 163.18 18.86 342.7 122.52 316.23 137.8 136.71 34.15 104.02 53.02 283.55 156.67 256.25 172.44 76.72 68.78 44.03 87.66 223.56 191.31 195.87 207.3 16.34 103.64 0 113.08 0 339.26 32.68 358.12 32.68 150.82 59.97 166.58 59.84 373.81 92.48 392.65 92.64 185.44 119.83 201.14 120 408.52 152.87 427.51 152.55 220.03 179.52 235.6 179.52 442.9 195.87 452.34 391.73 339.26 391.73 301.51 212.21 405.15"
});

var SvgLogoBlue = function SvgLogoBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 391.73 452.34",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoBlue.982a401a.svg";
export { ForwardRef as ReactComponent };